import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../routes';

export default function Navbar({ patientCount, currentUser, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  if (!currentUser) {
    return (
      <nav className="navbar animate-fade">
        <div className="navbar-inner">
          <div className="navbar-brand">
            <div className="brand-icon">🏥</div>
            <div className="brand-text">
              <span className="brand-name">MedSafety Connect</span>
              <span className="brand-tagline">Patient Care Portal</span>
            </div>
          </div>
        </div>
      </nav>
    );
  }

  const isPatient = currentUser.role === 'patient';
  const isSuperAdmin = currentUser.role === 'superadmin';

  const navItems = [];
  if (isPatient) {
    navItems.push([ROUTES.REGISTER_PERSONAL, '📋', 'Fill ADR Form']);
  } else {
    navItems.push([ROUTES.HOME, '🏠', 'Home']);
    navItems.push([ROUTES.DASHBOARD, '📊', 'Dashboard']);
    navItems.push([ROUTES.REGISTER_PERSONAL, '📋', 'New Patient Record']);
    navItems.push([ROUTES.QR, '📱', 'Scan QR']);
    if (isSuperAdmin) {
      navItems.push([ROUTES.ADMIN, '🛡️', 'Admin Panel']);
    }
  }

  const isActive = (path) => {
    if (path === ROUTES.REGISTER_PERSONAL) {
      return location.pathname.startsWith(ROUTES.REGISTER);
    }
    return location.pathname === path;
  };

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <button
          className="navbar-brand"
          onClick={() => navigate(isPatient ? ROUTES.REGISTER_PERSONAL : ROUTES.HOME)}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <div className="brand-icon">🏥</div>
          <div className="brand-text">
            <span className="brand-name">MedSafety Connect</span>
            <span className="brand-tagline">{isPatient ? 'Patient Portal' : 'Staff Dashboard'}</span>
          </div>
        </button>

        <ul className="navbar-nav">
          {navItems.map(([path, icon, label]) => (
            <li key={path}>
              <button
                className={`nav-link${isActive(path) ? ' active' : ''}`}
                onClick={() => navigate(path)}
              >
                {icon} {label}
              </button>
            </li>
          ))}
        </ul>

        <div className="navbar-actions" style={{ gap: '16px' }}>
          {!isPatient && (
            <div className="nav-stats-pill">
              <span className="nav-stats-dot"></span>
              {patientCount} Record{patientCount !== 1 ? 's' : ''}
            </div>
          )}

          <div className="navbar-profile-pill">
            <div className="profile-avatar-mini">
              {isPatient ? '👤' : currentUser.name?.[0]?.toUpperCase() || 'A'}
            </div>
            <div className="profile-details-mini">
              <span className="profile-name-mini">{isPatient ? 'Patient Portal' : currentUser.name}</span>
              <span className={`badge ${isSuperAdmin ? 'badge-danger' : isPatient ? 'badge-success' : 'badge-primary'}`} style={{ fontSize: '0.65rem', padding: '2px 6px', marginTop: '2px' }}>
                {isSuperAdmin ? '👑 Super' : isPatient ? '✓ Patient' : '🛡️ Staff'}
              </span>
            </div>
          </div>

          <button className="btn btn-outline" onClick={onLogout} style={{ padding: '6px 14px', fontSize: '0.78rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
            {isPatient ? '← Back to Admin Login' : '🚪 Exit'}
          </button>
        </div>
      </div>
    </nav>
  );
}

